import React from "react";
import { Image } from "react-konva";

interface Props {
  image: HTMLImageElement;
  setResolution: (resolution: [number, number]) => void;
}

const URLImage: React.FunctionComponent<Props> = (props) => {
  React.useEffect(() => {
    if (props.image.width > 0 && props.image.height > 0) {
      props.setResolution([props.image.width, props.image.height]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.image]);

  return <Image image={props.image} />;
};

export default URLImage;
